import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import metadata from './ProductsCoverageSelectionComponent.metadata.json5';

import styles from '../../../SpaAndWellCommonStyles.module.scss';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function ProductsCoverageSelectionComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('ProductsCoverageSelectionComponent');
    const modelVM = _.get(submissionVM, pathUpdated);
    const offPath = 'lobData.spaAndWellLine.coverables.healthWellness'

    modelVM.value.isValidationReq = true;

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        iftypofinsisoththeexpFie: {
            visible: !_.isUndefined(modelVM.value.othFie) && modelVM.value.othFie
        },
        equBreFie: {
            visible: !_.isUndefined(modelVM.value.proFie) && modelVM.value.proFie
        },
        criFie: {
            visible: !_.isUndefined(modelVM.value.proFie) && modelVM.value.proFie
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            if (changedPath === 'danStuFie') {
                if (!value) {
                    _.set(submissionVM, `${offPath}.danceDetails.isValidationReq`, false);
                } else {
                    _.set(submissionVM, `${offPath}.danceDetails.isValidationReq`, value);
                }
            }

            if (changedPath === 'heaCluFie') {
                if (!value) {
                    _.set(submissionVM, `${offPath}.healthClubFacility.isValidationReq`, false);
                    _.set(submissionVM, `${offPath}.healthClubFacility.percentageDTO.children[0].chiund12Fie.value`, 0);
                    _.set(submissionVM, `${offPath}.healthClubFacility.quantityDTO.children[0].aquTraFie.value`, 0);
                    _.set(submissionVM, `${offPath}.healthClubFacility.quantityDTO.children[0].strTraFie.value`, 0);
                } else {
                    _.set(submissionVM, `${offPath}.healthClubFacility.isValidationReq`, value);
                }
            }

            if (changedPath === 'marArtFie') {
                if (!value) {
                    _.set(submissionVM, `${offPath}.martialArts.isValidationReq`, false);
                } else {
                    _.set(submissionVM, `${offPath}.martialArts.isValidationReq`, value);
                }
            }

            if (changedPath === 'perTraFie') {
                if (!value) {
                    _.set(submissionVM, `${offPath}.personalTrainingMobile.isValidationReq`, false);
                } else {
                    _.set(submissionVM, `${offPath}.personalTrainingMobile.isValidationReq`, value);
                }
            }

            if (changedPath === 'tanSalFie1') {
                if (!value) {
                    _.set(submissionVM, `${offPath}.tanningSalonOperations.isValidationReq`, false);
                } else {
                    _.set(submissionVM, `${offPath}.tanningSalonOperations.isValidationReq`, value);
                }
            }

            if (changedPath === 'cybLiaFie') {
                if (!value) {
                    _.set(submissionVM, `${offPath}.cyber.isValidationReq`, false);
                } else {
                    _.set(submissionVM, `${offPath}.cyber.isValidationReq`, value);
                }
            }

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

ProductsCoverageSelectionComponent.propTypes = wizardProps;
export default withRouter(ProductsCoverageSelectionComponent);
